module.exports = __webpack_public_path__ + "img/slide-9.51223e88.jpeg";